import React, { useState } from "react";
import { getAuth } from "firebase/auth";
// ✅ Use proxy directly (safe)
const API_BASE_URL = "https://sellerproxy-kinm2tdd4q-uc.a.run.app";

if (!API_BASE_URL) {
  console.error("❌ API base URL is missing");
}

const PaymentButton = ({ setIsPaid, amount, validateForm, promoCode }) => {
  const [loading, setLoading] = useState(false);

  const isLegacyAndroid = () => {
    const ua = navigator.userAgent || "";
    return /Android [0-6]\./.test(ua);
  };

  const isInAppBrowser = () => {
    const ua = navigator.userAgent.toLowerCase();
    return (
      /fbav|instagram|line|wv|snapchat|linkedin|okhttp/.test(ua) ||
      (ua.includes("mobile") && ua.includes("version/") && !ua.includes("chrome"))
    );
  };

  const loadRazorpayScript = () =>
    new Promise((resolve, reject) => {
      if (window.Razorpay) return resolve(true);

      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.async = true;

      script.onload = () => resolve(true);
      script.onerror = () => reject("Failed to load Razorpay SDK");

      document.body.appendChild(script);
    });

  const handlePayment = async () => {
    if (!validateForm()) return;

    if (isLegacyAndroid()) {
      alert("⚠️ Please update your browser/device for payments.");
      return;
    }

    if (isInAppBrowser()) {
      alert("⚠️ Open this page in Chrome or system browser to pay.");
      return;
    }

    setLoading(true);

    try {
      await loadRazorpayScript();
	  const auth = getAuth();
const user = auth.currentUser;

if (!user) {
  alert("Please sign in first");
  setLoading(false);
  return;
}

const token = await user.getIdToken(true);

      /* =======================
         CREATE ORDER (PROXY)
      ======================= */
      const response = await fetch(
        `${API_BASE_URL}/api/create-order`,
        {
          method: "POST",
          headers: {
  "Content-Type": "application/json",
  "X-Firebase-Authorization": `Bearer ${token}`,
},
          body: JSON.stringify({ amount, promoCode })
        }
      );

      const data = await response.json();

      if (!data.success) {
        alert(data.error || "Failed to create order");
        setLoading(false);
        return;
      }

      /* =======================
         RAZORPAY CHECKOUT
      ======================= */
      const options = {
        key: "rzp_live_SpWRE4rvrkm2mD", // ✅ public key (safe)
        amount: data.amount,
        currency: data.currency,
        name: "Pitics Technologies",
        description: "Payment for PDF Download",
        image: "https://pitics.com/logo.png",
        order_id: data.orderId,
        theme: { color: "#3399cc" },

        handler: async function (response) {
          try {
            /* =======================
               VERIFY PAYMENT (PROXY)
            ======================= */

const currentUser = auth.currentUser;

if (!currentUser) {
  alert("Please sign in again");
  return;
}

const verifyToken = await currentUser.getIdToken(true);

const verifyRes = await fetch(
  `${API_BASE_URL}/api/verify-payment`,
  {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Firebase-Authorization": `Bearer ${verifyToken}`,
    },
    body: JSON.stringify({
      razorpay_order_id: response.razorpay_order_id,
      razorpay_payment_id: response.razorpay_payment_id,
      razorpay_signature: response.razorpay_signature
    })
  }
);

            const result = await verifyRes.json();

            if (result.success) {
              setIsPaid(true);
              //alert("✅ Payment successful!");
            } else {
              alert("❌ Payment verification failed. Contact support.");
            }
          } catch (err) {
            console.error("Verification error:", err);
            alert("❌ Payment verification failed.");
          }
        },

        method: {
          card: true,
          upi: true,
          wallet: true,
          netbanking: true
        },

        redirect: true
      };

      const rzp = new window.Razorpay(options);
      setTimeout(() => rzp.open(), 100);

    } catch (error) {
      console.error("❌ Payment error:", error);
      alert("❌ Payment failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handlePayment}
      disabled={loading}
      style={{
        padding: "10px 20px",
        fontSize: "16px",
        backgroundColor: loading ? "#6c757d" : "#28a745",
        color: "white",
        border: "none",
        borderRadius: "5px",
        cursor: loading ? "not-allowed" : "pointer"
      }}
    >
      {loading ? "Processing..." : `Pay ₹${amount / 100}`}
    </button>
  );
};

export default PaymentButton;
